import * as React from 'react';
import * as GetTournamentOrganizationById from '../../core/gql/queries/get-tournament-org-by-id';
import { useLazyQuery } from '@apollo/client';
import OrgAdminSearchField from './org-admin-search-field';

export interface Props {
  setTournamentOrg: Function;
  isDisabled: boolean;
}

const TournamentOrgIdSearchForm: React.FunctionComponent<Props> = ({ setTournamentOrg, isDisabled }) => {
  const [searching, setSearching] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState('');
  const [queryToggle, setQueryToggle] = React.useState(false);

  const onResults = (data) => {
    setQueryToggle(!queryToggle);
    setSearching(false);
    if (data?.getTournamentOrganizationById) {
      setTournamentOrg(data?.getTournamentOrganizationById);
    }
  };

  const onError = (error) => {
    setQueryToggle(!queryToggle);
    setSearching(false);
    if (error) {
      if (error.message.includes('not_found')) {
        setErrorMessage('Could not find tournament org.');
      } else {
        setErrorMessage(error.message.replace('Error: ', ''));
      }
    }
  };

  const [getDataByTournamentId] = useLazyQuery(GetTournamentOrganizationById.QUERY, {
    fetchPolicy: 'no-cache',
    nextFetchPolicy: 'no-cache',
    onCompleted: onResults,
    onError: onError,
  });

  const search = (searchUUID) => {
    // query toggle is needed to cause onCompleted to get called if run same query 2x in a row
    // and have a testable variable value for the Mocked Provider for tests
    getDataByTournamentId({ variables: { tournamentOrgId: searchUUID, queryToggle: queryToggle } });
  };

  return (
    <OrgAdminSearchField
      setSearching={setSearching}
      searching={searching}
      isDisabled={isDisabled}
      setErrorMessage={setErrorMessage}
      search={search}
      errorMessage={errorMessage}
      defaultLabel='TST ORG ID'
    />
  );
};

export default TournamentOrgIdSearchForm;
